var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue } from 'vue-property-decorator';
import * as yup from 'yup';
var TouristValidationMixin = /** @class */ (function (_super) {
    __extends(TouristValidationMixin, _super);
    function TouristValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TouristValidationMixin.prototype.isValidBirthDateFormat = function (value) {
        return /^\d{2}-\d{2}-\d{4}$/.test(value);
    };
    TouristValidationMixin.prototype.parseBirthDate = function (value) {
        if (!this.isValidBirthDateFormat(value))
            return null;
        var _a = value.split('-').map(Number), day = _a[0], month = _a[1], year = _a[2];
        var today = new Date();
        var currentYear = today.getFullYear();
        var minYear = currentYear - 75;
        if (day < 1 || day > 31)
            return null;
        if (month < 1 || month > 12)
            return null;
        if (year < minYear || year > currentYear)
            return null;
        var birthDate = new Date(year, month - 1, day);
        var isExactDate = birthDate.getFullYear() === year
            && birthDate.getMonth() === month - 1
            && birthDate.getDate() === day;
        return isExactDate ? birthDate : null;
    };
    TouristValidationMixin.prototype.isBirthDateWithinAllowedAge = function (value) {
        var birthDate = this.parseBirthDate(value);
        if (!birthDate)
            return false;
        var today = new Date();
        var todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        var seventyFiveYearsAgo = new Date(today.getFullYear() - 75, today.getMonth(), today.getDate());
        return birthDate <= todayStart && birthDate >= seventyFiveYearsAgo;
    };
    Object.defineProperty(TouristValidationMixin.prototype, "step1ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            return yup.object().shape({
                startDate: yup.string().required(t.start_date_required || 'Səfərin başlanğıc tarixi tələb olunur'),
                endDate: yup.string().required(t.end_date_required || 'Səfərin bitmə tarixi tələb olunur')
                    .test('is-after-start', t.end_date_after_start || 'Bitmə tarixi başlama tarixindən ən az 2 gün sonra olmalıdır', function (value) {
                    var startDate = this.parent.startDate;
                    if (!value || !startDate)
                        return true;
                    var start = new Date(startDate);
                    var end = new Date(value);
                    var diffDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
                    return diffDays >= 2;
                }),
                purpose: yup.string().required(t.purpose_required || 'Səfərin məqsədi seçilməlidir'),
                coverageAmount: yup.string().required(t.coverage_amount_required || 'Sığorta məbləği seçilməlidir')
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouristValidationMixin.prototype, "step2ValidationSchema", {
        get: function () {
            var _this = this;
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step2) || {};
            return yup.object().shape({
                prefix: yup.string().required(t.prefix_required || 'Ölkə kodu tələb olunur'),
                phone: yup.string().required(t.phone_required || 'Telefon nömrəsi tələb olunur')
                    .test('combined-phone', t.phone_invalid || 'Telefon nömrəsi düzgün formatda deyil', function (value) {
                    var prefix = this.parent.prefix;
                    if (!value || !prefix)
                        return true;
                    var combined = (prefix + value).replace(/[^\d+]/g, '');
                    return /^\+\d{5,15}$/.test(combined);
                }),
                lastName: yup.string().required(t.last_name_required || 'Soyad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.last_name_invalid || 'Soyad yalnız hərflərdən ibarət olmalıdır')
                    .max(50, t.last_name_max || 'Soyad maksimum 50 simvol ola bilər'),
                firstName: yup.string().required(t.first_name_required || 'Ad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.first_name_invalid || 'Ad yalnız hərflərdən ibarət olmalıdır')
                    .max(50, t.first_name_max || 'Ad maksimum 50 simvol ola bilər'),
                passport: yup.string().required(t.passport_required || 'Passport nömrəsi tələb olunur')
                    .matches(/^[A-Za-z0-9]+$/, t.passport_invalid || 'Passport nömrəsi yalnız ingilis hərfləri və rəqəmlərdən ibarət ola bilər'),
                birthDate: yup.string().required(t.birth_date_required || 'Doğum tarixi tələb olunur')
                    .matches(/^\d{2}-\d{2}-\d{4}$/, t.birth_date_invalid || 'Doğum tarixi düzgün deyil (DD-MM-YYYY)')
                    .test('is-valid-birth-date', t.birth_date_invalid || 'Doğum tarixi düzgün deyil (DD-MM-YYYY)', function (value) {
                    if (!value || !_this.isValidBirthDateFormat(value))
                        return false;
                    return _this.parseBirthDate(value) !== null;
                })
                    .test('is-valid-age', t.birth_date_age_invalid || 'Yaş maksimum 75 olmalıdır', function (value) {
                    if (!value || !_this.isValidBirthDateFormat(value))
                        return true;
                    if (_this.parseBirthDate(value) === null)
                        return true;
                    return _this.isBirthDateWithinAllowedAge(value);
                }),
                citizenship: yup.string().required(t.citizenship_required || 'Vətəndaşlıq seçilməlidir'),
                gender: yup.string().required(t.gender_required || 'Cins seçilməlidir')
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouristValidationMixin.prototype, "step3ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step3) || {};
            return yup.object().shape({
                company: yup.number().typeError(t.company_required || 'Sığorta şirkəti seçilməlidir')
                    .required(t.company_required || 'Sığorta şirkəti seçilməlidir')
            });
        },
        enumerable: false,
        configurable: true
    });
    TouristValidationMixin.prototype.validateStep1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1, errors_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Validating Step1...', this.stepsData.step1);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step1ValidationSchema.validate(this.stepsData.step1, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step1Errors = {};
                        return [2 /*return*/, true];
                    case 3:
                        err_1 = _a.sent();
                        errors_1 = {};
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) { errors_1[error.path] = error.message; });
                        }
                        this.step1Errors = errors_1;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TouristValidationMixin.prototype.validateStep2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2, errors_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Validating Step2...', this.stepsData.step2);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step2ValidationSchema.validate(this.stepsData.step2, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step2Errors = {};
                        return [2 /*return*/, true];
                    case 3:
                        err_2 = _a.sent();
                        errors_2 = {};
                        if (err_2.inner) {
                            err_2.inner.forEach(function (error) { errors_2[error.path] = error.message; });
                        }
                        this.step2Errors = errors_2;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TouristValidationMixin.prototype.validateStep3 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_3, errors_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Validating Step3...', this.stepsData.step1);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step3ValidationSchema.validate({ company: this.stepsData.step1.company }, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step3Errors = {};
                        return [2 /*return*/, true];
                    case 3:
                        err_3 = _a.sent();
                        errors_3 = {};
                        if (err_3.inner) {
                            err_3.inner.forEach(function (error) { errors_3[error.path] = error.message; });
                        }
                        this.step3Errors = errors_3;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TouristValidationMixin.prototype.validateCurrentStep = function (currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentStep === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateStep1()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(currentStep === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.validateStep2()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (!(currentStep === 3)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.validateStep3()];
                    case 5: return [2 /*return*/, _a.sent()];
                    case 6: return [2 /*return*/, true];
                }
            });
        });
    };
    TouristValidationMixin = __decorate([
        Component
    ], TouristValidationMixin);
    return TouristValidationMixin;
}(Vue));
export default TouristValidationMixin;
